import './CTUS.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CTUS extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.setContactForm();
		this.contactFormHideInputs();
		this.contactFormSubject.addEventListener('change', this.onSubjectChange.bind(this), false);
	}

	setContactForm () {
		this.contactForm = document.getElementById('js-form--ctus_form');
		this.contactFormSubject = this.contactForm.querySelector('.g-form-select__dropdown');
		this.contactFormSalesOrderNumber = this.contactForm.querySelector('.g-form-list__item--ctus_sales_order_number');
		this.contactFormCouponCode = this.contactForm.querySelector('.g-form-list__item--ctus_coupon_code');
		this.contactFormItemNumber = this.contactForm.querySelector('.g-form-list__item--ctus_item_number');
	}

	contactFormHideInputs () {
		this.contactFormSalesOrderNumber.style.display = 'none';
		this.contactFormCouponCode.style.display = 'none';
		this.contactFormItemNumber.style.display = 'none';
	}

	onSubjectChange () {
		switch (this.contactFormSubject.selectedIndex) {
			case 1:
			case 2:
			case 3:
			case 5:
			case 7:
			case 11:
				this.contactFormSalesOrderNumber.style.display = 'block';
				this.contactFormCouponCode.style.display = 'none';
				this.contactFormItemNumber.style.display = 'none';
				break;
			case 6:
				this.contactFormSalesOrderNumber.style.display = 'block';
				this.contactFormCouponCode.style.display = 'block';
				this.contactFormItemNumber.style.display = 'none';
				break;
			case 8:
				this.contactFormSalesOrderNumber.style.display = 'none';
				this.contactFormCouponCode.style.display = 'none';
				this.contactFormItemNumber.style.display = 'block';
				break;
			default:
				this.contactFormSalesOrderNumber.style.display = 'none';
				this.contactFormCouponCode.style.display = 'none';
				this.contactFormItemNumber.style.display = 'none';
		}
	}

};
